import ReactMarkdown from 'react-markdown';

// Render simples de Markdown (negrito, listas, quebras de linha) com estilo da app.
export function Markdown({ children, className = '' }) {
  if (!children) return null;
  return (
    <div className={`md-content text-sm text-brand-muted leading-relaxed ${className}`}>
      <ReactMarkdown
        components={{
          p: ({ node, ...props }) => <p className="mb-2 last:mb-0" {...props} />,
          ul: ({ node, ...props }) => <ul className="list-disc pl-5 mb-2 space-y-0.5" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal pl-5 mb-2 space-y-0.5" {...props} />,
          li: ({ node, ...props }) => <li {...props} />,
          strong: ({ node, ...props }) => <strong className="font-semibold text-brand-text" {...props} />,
          a: ({ node, ...props }) => <a className="text-brand-green underline" target="_blank" rel="noreferrer" {...props} />,
          h1: ({ node, ...props }) => <p className="font-semibold text-brand-text mb-1" {...props} />,
          h2: ({ node, ...props }) => <p className="font-semibold text-brand-text mb-1" {...props} />,
          h3: ({ node, ...props }) => <p className="font-semibold text-brand-text mb-1" {...props} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}

export default Markdown;
